var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "esf-main-container" },
    [
      _c(
        "div",
        {
          staticStyle: {
            "background-color": "white",
            "border-radius": "8px",
            border: "1px solid #dee2e6",
            padding: "10px"
          }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-column button-column",
                  attrs: { lg: "2" }
                },
                [
                  _c(
                    "button",
                    {
                      class: [
                        "process-btn-container",
                        _vm.disableSaveButton
                          ? "disabled-btn"
                          : "fill-color-btn-color"
                      ],
                      attrs: { size: "sm", disabled: _vm.disableSaveButton },
                      on: { click: _vm.CheckboxSave }
                    },
                    [
                      _c("span", {
                        attrs: { "aria-label": "Save" },
                        domProps: { innerHTML: _vm._s(_vm.svg.SaveIcon) }
                      }),
                      _vm._v("\n          Save\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "process-btn-container outline-btn-color",
                      attrs: { size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.clearEditedAttachedPages()
                          _vm.CheckboxClear()
                          _vm.anyCheckboxSelected = false
                        }
                      }
                    },
                    [
                      _c("span", {
                        attrs: { "aria-label": "Reset" },
                        domProps: { innerHTML: _vm._s(_vm.svg.ResetUndoIcon) }
                      }),
                      _vm._v("\n          Reset\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "process-btn-container outline-btn-color",
                      attrs: { size: "sm" },
                      on: { click: _vm.showRejectFormModal }
                    },
                    [
                      _c("span", {
                        attrs: { "aria-label": "Reject" },
                        domProps: { innerHTML: _vm._s(_vm.svg.RejectCloseIcon) }
                      }),
                      _vm._v("\n          Reject\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class: [
                        "process-btn-container",
                        _vm.processButtonDisabled ||
                        Object.keys(_vm.selectedTitleDocs).length <= 0
                          ? "light-blue-btn"
                          : "fill-color-btn-color"
                      ],
                      attrs: {
                        size: "sm",
                        disabled:
                          _vm.processButtonDisabled ||
                          Object.keys(_vm.selectedTitleDocs).length <= 0
                      },
                      on: { click: _vm.doProcess }
                    },
                    [
                      _vm.processButtonDisabled
                        ? _c("i", {
                            staticClass: "fa fa-spin fa-spinner",
                            staticStyle: { "margin-right": "5px" }
                          })
                        : _c("span", {
                            attrs: { "aria-label": "Export" },
                            domProps: {
                              innerHTML: _vm._s(_vm.svg.ProcessPlayIcon)
                            }
                          }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.processButtonDisabled
                              ? "Processing..."
                              : "Export"
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "table-column", attrs: { lg: "10" } },
                [
                  _c("b-card", { staticClass: "table-con" }, [
                    _vm.isRotatedDoc
                      ? _c("div", { staticClass: "notes-margin" }, [
                          _c("ul", [
                            _c(
                              "h5",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("Note:")]
                            ),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "Kindly choose an image and adjust its orientation as needed."
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "After rotating the pages, hit Export to see the whole document with the changes in Salesforce."
                              )
                            ])
                          ])
                        ])
                      : _c(
                          "div",
                          [
                            _c("b-col", { attrs: { lg: "12" } }, [
                              _c("table", { staticClass: "result" }, [
                                _c(
                                  "thead",
                                  { staticClass: "esf-table-header-con" },
                                  [
                                    _c("tr", [
                                      !_vm.isRotatedDoc
                                        ? _c(
                                            "th",
                                            {
                                              staticClass:
                                                "table-padding table-left-align"
                                            },
                                            [_vm._v(" File Type ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "table-padding table-center-align"
                                        },
                                        [_vm._v(" Page Numbers ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "table-padding table-center-align"
                                        },
                                        [_vm._v(" Action ")]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.selectedTitleDocs, function(
                                    value,
                                    key
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        key: key,
                                        class: _vm.getResultCss(value),
                                        staticStyle: {
                                          "font-size": "12px",
                                          "line-height": "1.2"
                                        }
                                      },
                                      [
                                        !_vm.isRotatedDoc
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "black-border-btm table-left-align table-padding"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    value.template_doc.text
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "table-padding",
                                            staticStyle: {
                                              "text-align": "center",
                                              "border-bottom":
                                                "1px solid #dee2e6"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(value.pages.join(", "))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "table-padding",
                                            staticStyle: {
                                              "text-align": "center",
                                              "border-bottom":
                                                "1px solid #dee2e6"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.viewport",
                                                    modifiers: {
                                                      hover: true,
                                                      viewport: true
                                                    }
                                                  }
                                                ],
                                                staticStyle: {
                                                  "border-radius": "5px",
                                                  padding: "0px 6px 0px 6px"
                                                },
                                                attrs: {
                                                  variant: "white",
                                                  title: "Edit"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.editPages(value, key)
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.svg.EditPencilIcon
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.viewport",
                                                    modifiers: {
                                                      hover: true,
                                                      viewport: true
                                                    }
                                                  }
                                                ],
                                                staticStyle: {
                                                  "border-radius": "5px",
                                                  padding: "0px 6px 0px 6px"
                                                },
                                                attrs: {
                                                  variant: "white",
                                                  title: "Remove"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.removePages(value, key)
                                                    _vm.anyCheckboxSelected = false
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.svg.DeleteTrashIcon
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                )
                              ])
                            ])
                          ],
                          1
                        )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "background-color": "white",
            "border-radius": "8px",
            border: "1px solid #dee2e6",
            "margin-top": "12px"
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "align-items-center" },
            [
              _c("b-col", { attrs: { lg: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center flex-wrap"
                  },
                  [
                    _c("div", { staticClass: "ml-2 mr-3" }, [
                      _c(
                        "div",
                        { staticClass: "select-input-container" },
                        [
                          _c("b-form-select", {
                            staticClass: "custom-b-form-select",
                            attrs: {
                              plain: true,
                              options: _vm.setFormTypeOptions,
                              disabled: _vm.isRotatedDoc,
                              placeholder: "Select File Type",
                              id: "documentTypeSelect"
                            },
                            on: { change: _vm.disableCheckboxOnEditedDoc },
                            model: {
                              value: _vm.formType,
                              callback: function($$v) {
                                _vm.formType = $$v
                              },
                              expression: "formType"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "documentTypeSelect" } },
                            [_vm._v("File Type")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.viewport",
                            modifiers: { hover: true, viewport: true }
                          }
                        ],
                        staticClass: "mr-3 d-flex align-items-center",
                        staticStyle: { cursor: "pointer" },
                        attrs: { title: "Select All Thumbnails" },
                        on: { click: _vm.toggleAllThumbnails }
                      },
                      [
                        _vm.selectAllThumbnails
                          ? _c("span", {
                              staticClass: "fa fa-check-circle",
                              style: {
                                "font-size": "1.5em",
                                color: "#015BAC",
                                "margin-right": "5px",
                                "padding-left": "10px"
                              },
                              attrs: { "aria-hidden": "true" }
                            })
                          : _c("span", {
                              style: {
                                "font-size": "1.5em",
                                color: "gray",
                                "margin-right": "5px",
                                "padding-left": "10px"
                              },
                              domProps: {
                                innerHTML: _vm._s(_vm.svg["CircleOutlineIcon"])
                              }
                            }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "mt-2",
                            staticStyle: { "font-weight": "bold" }
                          },
                          [_vm._v("Select All")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "mt-2",
                        staticStyle: {
                          "border-radius": "6px",
                          height: "30px",
                          color: "black",
                          "background-color": "white",
                          border: "none",
                          "margin-right": "5px",
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                          outline: "none !important",
                          "box-shadow": "none !important"
                        },
                        attrs: { size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.rotateSelectedImgs(-90)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticStyle: { padding: "2px" },
                          domProps: {
                            innerHTML: _vm._s(_vm.svg["RotateLeftIcon"])
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "mt-2",
                        staticStyle: {
                          "border-radius": "6px",
                          height: "30px",
                          color: "black",
                          "background-color": "white",
                          border: "none",
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                          outline: "none !important",
                          "box-shadow": "none !important"
                        },
                        attrs: { size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.rotateSelectedImgs(+90)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticStyle: { padding: "2px" },
                          domProps: {
                            innerHTML: _vm._s(_vm.svg["RotateRightIcon"])
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", {
            staticStyle: {
              "border-top": "2px solid #eee",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "scrollable-content", attrs: { lg: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-3",
                      staticStyle: { "border-radius": "8px", border: "none" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "background-color": "white",
                            padding: "10px",
                            "border-bottom-left-radius": "8px",
                            "border-bottom-right-radius": "8px",
                            "overflow-x": "auto"
                          }
                        },
                        [
                          _c(
                            "Container",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "nowrap",
                                "min-width": "500rem"
                              },
                              attrs: {
                                orientation: "horizontal",
                                "get-child-payload": _vm.getCardPayload(
                                  "Templates"
                                ),
                                "drag-class": "card-ghost",
                                "drop-class": "card-ghost-drop",
                                "drop-placeholder": _vm.dropPlaceholderOptions
                              },
                              on: {
                                drop: function(e) {
                                  return _vm.onCardDrop("Templates", e)
                                },
                                "drag-start": function(e) {
                                  return _vm.log("drag start", e)
                                },
                                "drag-end": function(e) {
                                  return _vm.log("drag end", e)
                                }
                              }
                            },
                            [
                              _vm.scene.children[0] &&
                              _vm.scene.children[0].name === "Templates"
                                ? _vm._l(
                                    _vm.scene.children[0].children,
                                    function(card) {
                                      return _c(
                                        "Draggable",
                                        {
                                          key: card.id,
                                          staticStyle: {
                                            padding: "1px",
                                            width: "25rem"
                                          }
                                        },
                                        [
                                          (_vm.isEditedDoc
                                          ? card.data.form &&
                                            card.data.form.isEdited === true
                                          : card.data.form &&
                                            card.data.form.process !== true)
                                            ? _c("div", [
                                                card.data.found &&
                                                card.data.form
                                                  ? _c(
                                                      "div",
                                                      {
                                                        class:
                                                          card.props.className,
                                                        style:
                                                          card.data.form
                                                            .process == true
                                                            ? "border: 2px solid green"
                                                            : "border: none;"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-content-start align-items-center"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "checkbox-padding"
                                                              },
                                                              [
                                                                !card.data.form
                                                                  .isEdited
                                                                  ? _c(
                                                                      "input",
                                                                      {
                                                                        ref:
                                                                          "CheckboxClicks",
                                                                        refInFor: true,
                                                                        staticClass:
                                                                          "thumbnail-checkbox",
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox",
                                                                          id:
                                                                            card.id
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.updateDisableCheckBox()
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.editedCheckedBoxes,
                                                                            expression:
                                                                              "editedCheckedBoxes"
                                                                          }
                                                                        ],
                                                                        ref:
                                                                          "CheckboxClicks",
                                                                        refInFor: true,
                                                                        staticClass:
                                                                          "thumbnail-checkbox",
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox",
                                                                          id:
                                                                            card.id
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            card
                                                                              .data
                                                                              .form
                                                                              .id,
                                                                          checked: Array.isArray(
                                                                            _vm.editedCheckedBoxes
                                                                          )
                                                                            ? _vm._i(
                                                                                _vm.editedCheckedBoxes,
                                                                                card
                                                                                  .data
                                                                                  .form
                                                                                  .id
                                                                              ) >
                                                                              -1
                                                                            : _vm.editedCheckedBoxes
                                                                        },
                                                                        on: {
                                                                          change: [
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              var $$a =
                                                                                  _vm.editedCheckedBoxes,
                                                                                $$el =
                                                                                  $event.target,
                                                                                $$c = $$el.checked
                                                                                  ? true
                                                                                  : false
                                                                              if (
                                                                                Array.isArray(
                                                                                  $$a
                                                                                )
                                                                              ) {
                                                                                var $$v =
                                                                                    card
                                                                                      .data
                                                                                      .form
                                                                                      .id,
                                                                                  $$i = _vm._i(
                                                                                    $$a,
                                                                                    $$v
                                                                                  )
                                                                                if (
                                                                                  $$el.checked
                                                                                ) {
                                                                                  $$i <
                                                                                    0 &&
                                                                                    (_vm.editedCheckedBoxes = $$a.concat(
                                                                                      [
                                                                                        $$v
                                                                                      ]
                                                                                    ))
                                                                                } else {
                                                                                  $$i >
                                                                                    -1 &&
                                                                                    (_vm.editedCheckedBoxes = $$a
                                                                                      .slice(
                                                                                        0,
                                                                                        $$i
                                                                                      )
                                                                                      .concat(
                                                                                        $$a.slice(
                                                                                          $$i +
                                                                                            1
                                                                                        )
                                                                                      ))
                                                                                }
                                                                              } else {
                                                                                _vm.editedCheckedBoxes = $$c
                                                                              }
                                                                            },
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              _vm.updateDisableCheckBox()
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  margin: "8px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Page: " +
                                                                    _vm._s(
                                                                      card.data
                                                                        .form
                                                                        .original_page_no
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("img", {
                                                          staticClass:
                                                            "card-img",
                                                          style: {
                                                            transform:
                                                              "rotate(" +
                                                              card.data.form
                                                                .rotation +
                                                              "deg)"
                                                          },
                                                          attrs: {
                                                            onContextMenu:
                                                              "return false;",
                                                            width: "200",
                                                            height: "380",
                                                            src: card.data.form
                                                              ? _vm.axios.defaults.baseURL.replace(
                                                                  "/api",
                                                                  ""
                                                                ) +
                                                                card.data.form
                                                                  .image_thumbnail
                                                              : "",
                                                            id:
                                                              card.data.form
                                                                .id +
                                                              card.data.form
                                                                .original_title
                                                          },
                                                          on: {
                                                            load: function(
                                                              $event
                                                            ) {
                                                              _vm.loadingImage(
                                                                $event,
                                                                card.data.form
                                                              )
                                                            },
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.viewFullImage(
                                                                card.data.form,
                                                                "singleColumnName"
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _c("img", {
                                                        staticClass: "card-img",
                                                        attrs: {
                                                          onContextMenu:
                                                            "return false;",
                                                          width: "200",
                                                          height: "239"
                                                        }
                                                      })
                                                    ])
                                              ])
                                            : _c("div", [
                                                _c("img", {
                                                  staticClass: "card-img",
                                                  attrs: {
                                                    onContextMenu:
                                                      "return false;",
                                                    width: "200",
                                                    height: "239"
                                                  }
                                                })
                                              ])
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "viewFullImage",
          staticClass: "modal-primary",
          attrs: {
            size: "lg",
            centered: "",
            id: "hideModal",
            "no-close-on-esc": "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "modal-header" }, slot: "modal-header" },
            [
              _c("label", [_vm._v(_vm._s(_vm.selectedImage.title))]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.viewport",
                      modifiers: { hover: true, viewport: true }
                    }
                  ],
                  staticStyle: { padding: "4px 8px", "border-radius": "0px" },
                  attrs: {
                    size: "sm",
                    variant: "dark",
                    title: _vm.$t("FORMS.ROTATE_LEFT")
                  },
                  on: {
                    click: function($event) {
                      _vm.imageRotateLeft()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-undo" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.viewport",
                      modifiers: { hover: true, viewport: true }
                    }
                  ],
                  staticStyle: { padding: "4px 8px", "border-radius": "0px" },
                  attrs: {
                    size: "sm",
                    variant: "dark",
                    title: _vm.$t("FORMS.ROTATE_RIGHT")
                  },
                  on: {
                    click: function($event) {
                      _vm.imageRotateRight()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-repeat" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: 12 } }, [
                _c(
                  "div",
                  { staticStyle: { height: "75vh", "overflow-y": "auto" } },
                  [
                    _vm.modelOpen
                      ? _c("img", {
                          staticClass: "card-img",
                          staticStyle: { width: "80%" },
                          style: { transform: "rotate(" + this.angle + "deg)" },
                          attrs: {
                            onContextMenu: "return false;",
                            src: _vm.selectedImage
                              ? _vm.axios.defaults.baseURL.replace("/api", "") +
                                _vm.selectedImage.image_url
                              : "",
                            id: _vm.selectedImage.id
                          },
                          on: {
                            load: function($event) {
                              _vm.loadingImage($event, _vm.selectedImage)
                            }
                          }
                        })
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.saveRotationTemplateImage()
                    }
                  }
                },
                [_vm._v(" Save ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.closeRotationTemplateImage()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rejectFormDoc",
          attrs: {
            "hide-header-close": "",
            title: "Reject Form",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c("div", {
            staticClass: "reject-bg-con-color warning-con mb-2",
            domProps: { innerHTML: _vm._s(_vm.svg.rejectExclamation) }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Do you want to reject this document?")]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn",
                  attrs: { size: "sm" },
                  on: { click: _vm.hideRejectFormDocModal }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn",
                  attrs: { size: "sm" },
                  on: { click: _vm.rejectForm }
                },
                [_vm._v("Confirm")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rotatePagesAlert",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c("div", {
            staticClass: "warning-con warning-bg-con-color mb-2",
            domProps: { innerHTML: _vm._s(_vm.svg.warningAlert) }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Kindly Select atleast one form to rotate")]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn",
                  attrs: { size: "sm" },
                  on: {
                    click: function($event) {
                      _vm.$refs.rotatePagesAlert.hide()
                    }
                  }
                },
                [_vm._v("Okay")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "splitDocAlert",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c("div", {
            staticClass: "warning-con warning-bg-con-color mb-2",
            domProps: { innerHTML: _vm._s(_vm.svg.warningAlert) }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Please complete the form split before exporting")]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn",
                  attrs: { size: "sm" },
                  on: {
                    click: function($event) {
                      _vm.$refs.splitDocAlert.hide()
                    }
                  }
                },
                [_vm._v("Okay")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc075dfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc075dfa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forms/ESFTriagingProcessedForm.vue
// module id = 1441
// module chunks = 2